export const PROPERTY_TYPE = 'Property Type';
export const OCCUPANCY_TYPE = 'Occupancy Type';

export const SINGLE_FAMILY = 'Single Family';
export const MULTI_FAMILY = 'Multi Family';
export const APARTMENT = 'Apartment';
export const CONDO = 'Condo';

export const ALL_PROPERTY_TYPES = [SINGLE_FAMILY, MULTI_FAMILY, APARTMENT, CONDO];

export const PRIMARY_RESIDENCE = 'Primary';
export const SECONDARY = 'Secondary';
export const INVESTMENT = 'Investment';

export const ALL_OCCUPANCY_TYPES = [PRIMARY_RESIDENCE, SECONDARY, INVESTMENT];

export const MORTGAGES = 'Mortgages';

export const MORTGAGES_DROPDOWN_OPTIONS = [
  { title: '10 Year', value: 10 },
  { title: '15 Year', value: 15 },
  { title: '20 Year', value: 20 },
  // { title: '25 Year', value: 25 },
  { title: '30 Year', value: 30 },
];

export const DEFAULT_MORTGAGE = [30];
